import { createDomain } from 'effector';

import { type QuestionnaireInstance } from 'types/zod/questionnaire-instance';

const domain = createDomain('q-instances');

export const $qInstances = domain.store<
    Record<QuestionnaireInstance['questionnaire_instance_id'], QuestionnaireInstance>
>({});
